import React, { PropsWithChildren, SyntheticEvent } from "react";

import { Button } from "@components/General/Button/button.component";
import { useCallToActionContext } from "@components/General/CallToAction/callToAction.context";

type AddToCartButtonComponentProps = PropsWithChildren<{
    onClick: (event: SyntheticEvent<HTMLButtonElement>) => void;
}>;

const AddToCartButtonComponent = ({
    onClick,
    children,
}: AddToCartButtonComponentProps) => {
    const { trackingProperties, styleProperties } = useCallToActionContext();

    return (
        <Button
            type="submit"
            {...styleProperties.button}
            dataAttributes={trackingProperties.click}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};

export { AddToCartButtonComponent };
